import { render, staticRenderFns } from "./InteractiveTextCanvas.vue?vue&type=template&id=bd0ca8e8"
import script from "./InteractiveTextCanvas.vue?vue&type=script&lang=js"
export * from "./InteractiveTextCanvas.vue?vue&type=script&lang=js"
import style0 from "./InteractiveTextCanvas.vue?vue&type=style&index=0&id=bd0ca8e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports